import { httpGatewayService } from "@/modules/common/services";
import {notificationCenterService} from "../../notificationCenter/services/notificationCenterService";


const baseRoute = 'business/notificationscenter/v1'
const settingsRoute = 'staff/settings'

const getStaffSettings = async (staffUid) => {
  return await httpGatewayService.get(`${baseRoute}/${settingsRoute}?filter[staff_uid][eq]=${staffUid}&per_page=100`)
    .then(res => {
      return res.data?.staff_settings
    })
}


const updateSingleSetting = async (setting) =>{
  try{
    return await httpGatewayService.put(`${baseRoute}/${settingsRoute}/${setting.uid}`, {
      ...setting
    })
      .then(res => {
        return res.data
      })
  }
  catch (e){
    console.log(e)
  }
}

const createSingleSetting = async (setting) => {
  try{
    return await httpGatewayService.post(`${baseRoute}/${settingsRoute}`, {
      ...setting
    }).then(res => res.data)
  }
  catch (e){
    console.log(e)
  }
}


const composeSettingsData = async (staffUid, usedApps, businessLocale) =>{
  const response = await Promise.all([
    getStaffSettings(staffUid),
    notificationCenterService.fetchDataFromDB('notificationsMetadata',notificationCenterService.getNotificationsMetadata),
    notificationCenterService.fetchDataFromDB('notificationsTypes',notificationCenterService.getNotificationsTypes),
    notificationCenterService.fetchDataFromDB('notificationsTranslations',notificationCenterService.getNotificationsTranslations),
    ])

  const settings = response[0]
  const metadata = response[1]
  const types = response[2]
  const translations = response[3]

  const mappedSettings = {
    payments:[],
    scheduling:[],
    clients:[],
    marketing:[],
    teamchat:[],
    advertising:[],
    reviews:[],
    messages:[],
    group_events:[],
    documents:[],
    category: {},
  }

  metadata.forEach(metaRow => {
    const matchingType = types.find(type => type.uid === metaRow.notification_type_uid)
    const matchingSetting = settings.find(setting => setting.notification_metadata_uid === metaRow.uid)
    const matchingTranslation = translations.find(translation => translation.notification_metadata_uid === metaRow.uid)
    const relevantLocaleTranslation = matchingTranslation?.[businessLocale] ? JSON.parse(matchingTranslation[businessLocale]) : ""
    const defaultTranslation = matchingTranslation?.['en'] ? JSON.parse(matchingTranslation['en']) : ""
    mappedSettings.category[metaRow.category] = true

    const value = {
      uid: matchingSetting?.uid,
      staff_uid: staffUid,
      notification_metadata_uid: metaRow.uid,
      push: getSettingChoice(matchingSetting, 'push'),
      pane: getSettingChoice(matchingSetting, 'pane'),
      email: getSettingChoice(matchingSetting, 'email'),
      sms: getSettingChoice(matchingSetting, 'sms', false),
      notification_code_name: metaRow.notification_code_name,
      display_name: getRelevantDisplayName(defaultTranslation, relevantLocaleTranslation),
      description: getRelevantDescription(defaultTranslation, relevantLocaleTranslation),
      display_push: metaRow.push,
      display_pane: metaRow.pane,
      display_email: metaRow.email,
      display_sms: metaRow.sms,
      category: metaRow.category,
    }
    if(shouldDisplaySetting(matchingType, mappedSettings, metaRow, usedApps))
      mappedSettings[matchingType.name].push(value)
  })
  return mappedSettings;
}

const shouldDisplaySetting = (settingType, settingsCategories, metadataRow, apps) => {
  const hasRelatedApp = apps.find(app => app.app_code_name === metadataRow.creator_identifier)
  const isCreatorTypeDir = metadataRow.creator_type === 'directory'
  const isProduction = window.app_config.env.production
  const isCreatorCoreInternal = metadataRow.creator_identifier === 'CoreInternalApp'
  const isCreatorTypeApp = (metadataRow.creator_type === 'app' && !isCreatorCoreInternal)
  const isValidAppCreator = isCreatorTypeApp && hasRelatedApp
  const isValidCreator = !!(isValidAppCreator || isCreatorCoreInternal)
  const isValidCreatorForIntegration = !!(isCreatorTypeDir || isValidAppCreator || isCreatorCoreInternal)
  const isValidSetting =  metadataRow.show_in_settings && (isProduction ? isValidCreator : isValidCreatorForIntegration)
  const isValidCategory = Object.keys(settingsCategories).includes(settingType?.name)
  return isValidCategory && isValidSetting
}

const getRelevantDisplayName = (defaultTranslation, localeTranslation) => {
  return getRelevantValue(defaultTranslation, localeTranslation, "display_name")
}

const getRelevantDescription = (defaultTranslation, localeTranslation) => {
  return getRelevantValue(defaultTranslation, localeTranslation, "description")
}

const getRelevantValue = (defaultTranslation, localeTranslation, key) =>{
  return localeTranslation?.[key] ? localeTranslation[key] : defaultTranslation?.[key];
}

const getSettingChoice = (setting, key, defaultState = true) =>{
  return setting ? setting[key] : defaultState
}

export const NotificationsSettingsService = {
  composeSettingsData,
  getStaffSettings,
  updateSingleSetting,
  createSingleSetting
}
